export const gender_data = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
  ];

  export const status_data = [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];

  export const Marital = [
    { value: "Single", label: "Single" },
    { value: "Married", label: "Married" },
  ];

  export const Contract = [
    { value: "Permanent", label: "Permanent" },
    { value: "Temporary", label: "Temporary" },
  ];

  export const religion_data = [
    { value: "Islam", label: "Islam" },
    { value: "Buddhism", label: "Buddhism" },
    { value: "Hinduism", label: "Hinduism" },
    { value: "Christianity", label: "Christianity"},
    { value: "Other", label: "Other"}
  ];

  export const race_data = [
    { value: "Malay", label: "Malay" },
    { value: "Chinese", label: "Chinese" },
    { value: "Indians", label: "Indians" },
    { value: "Other", label: "Other" },
  ];

  export const bloodGroup = [
    { value: "O +ve", label: "O +ve" },
    { value: "O -ve", label: "O -ve" },
    { value: "B +ve", label: "B +ve" },
  ];

  export const allSection = [
    { value: "", label: "Select" },
    { value: "1", label: "Jupiter" },
    { value: "2", label: "Mars" },
  ];

  export const allClass = [
    { value: "", label: "Select" },
    { value: "1", label: "Year 1" },
    { value: "2", label: "Year 2" },
    { value: "3", label: "Year 3" },
    { value: "4", label: "Year 4" },
    { value: "5", label: "Year 5" },
    { value: "6", label: "Year 6" },
    { value: "7", label: "Year 7" },
    { value: "8", label: "Year 8" },
    { value: "9", label: "Year 9" },
    { value: "10", label: "Year 10" },
    { value: "11", label: "Year 11" },
    { value: "12", label: "Year 12" },
  ];
 
  export const allSubject = [
    { value: "B.Malay", label: "B.Malay" },
    { value: "English", label: "English" },
    { value: "Mathematic", label: "Mathematic" },
    { value: "Science", label: "Science" },
    { value: "History", label: "History" },
    { value: "Geography", label: "Geography" },
    { value: "Moral", label: "Moral" },
    { value: "ICT", label: "ICT1" },
  ];

  export const months = [
    { value: "January", label: "January" },
    { value: "February", label: "February" },
    { value: "March", label: "March" },
    { value: "April", label: "April" },
    { value: "May", label: "May" },
    { value: "June", label: "June" },
    { value: "July", label: "July" },
    { value: "August", label: "August" },
    { value: "September", label: "September" },
    { value: "October", label: "October" },
    { value: "November", label: "November" },
    { value: "December", label: "December" },
  ];

  export const Role = [
    { value: "Select", label: "Select" },
    { value: "Student", label: "Student" },
    { value: "Teacher", label: "Teacher" },
    { value: "Class Teacher", label: "Class Teacher" },
    { value: "Principle", label: "Principle" },
    { value: "Admin", label: "Admin" },
  ];

  export const nationality_data = [
    { value: "Afghanistan", label: "Afghanistan" },
    { value: "Albania", label: "Albania" },
    { value: "Algeria", label: "Algeria" },
    { value: "Andorra", label: "Andorra" },
    { value: "Angola", label: "Angola" },
    { value: "Antigua & Deps", label: "Antigua & Deps" },
    { value: "Argentina", label: "Argentina" },
    { value: "Armenia", label: "Armenia" },
    { value: "Australia", label: "Australia" },
    { value: "Austria", label: "Austria" },
    { value: "Azerbaijan", label: "Azerbaijan" },
    { value: "Bahamas", label: "Bahamas" },
    { value: "Bahrain", label: "Bahrain" },
    { value: "Bangladesh", label: "Bangladesh" },
    { value: "Barbados", label: "Barbados" },
    { value: "Belarus", label: "Belarus" },
    { value: "Belgium", label: "Belgium" },
    { value: "Belize", label: "Belize" },
    { value: "Benin", label: "Benin" },
    { value: "Bhutan", label: "Bhutan" },
    { value: "Bolivia", label: "Bolivia" },
    { value: "Bosnia Herzegovina", label: "Bosnia Herzegovina" },
    { value: "Botswana", label: "Botswana" },
    { value: "Brazil", label: "Brazil" },
    { value: "Brunei", label: "Brunei" },
    { value: "Bulgaria", label: "Bulgaria" },
    { value: "Burkina", label: "Burkina" },
    { value: "Burundi", label: "Burundi" },
    { value: "Cambodia", label: "Cambodia" },
    { value: "Cameroon", label: "Cameroon" },
    { value: "Canada", label: "Canada" },
    { value: "Cape Verde", label: "Cape Verde" },
    { value: "Central African Rep", label: "Central African Rep" },
    { value: "Chad", label: "Chad" },
    { value: "Chile", label: "Chile" },
    { value: "China", label: "China" },
    { value: "Colombia", label: "Colombia" },
    { value: "Comoros", label: "Comoros" },
    { value: "Congo", label: "Congo" },
    { value: "Congo {Democratic Rep}", label: "Congo {Democratic Rep}" },
    { value: "Costa Rica", label: "Costa Rica" },
    { value: "Croatia", label: "Croatia" },
    { value: "Cuba", label: "Cuba" },
    { value: "Cyprus", label: "Cyprus" },
    { value: "Czech Republic", label: "Czech Republic" },
    { value: "Denmark", label: "Denmark" },
    { value: "Djibouti", label: "Djibouti" },
    { value: "Dominica", label: "Dominica" },
    { value: "Dominican Republic", label: "Dominican Republic" },
    { value: "East Timor", label: "East Timor" },
    { value: "Ecuador", label: "Ecuador" },
    { value: "Egypt", label: "Egypt" },
    { value: "El Salvador", label: "El Salvador" },
    { value: "Equatorial Guinea", label: "Equatorial Guinea" },
    { value: "Eritrea", label: "Eritrea" },
    { value: "Estonia", label: "Estonia" },
    { value: "Ethiopia", label: "Ethiopia" },
    { value: "Fiji", label: "Fiji" },
    { value: "Finland", label: "Finland" },
    { value: "France", label: "France" },
    { value: "Gabon", label: "Gabon" },
    { value: "Gambia", label: "Gambia" },
    { value: "Georgia", label: "Georgia" },
    { value: "Germany", label: "Germany" },
    { value: "Ghana", label: "Ghana" },
    { value: "Greece", label: "Greece" },
    { value: "Grenada", label: "Grenada" },
    { value: "Guatemala", label: "Guatemala" },
    { value: "Guinea", label: "Guinea" },
    { value: "Guinea-Bissau", label: "Guinea-Bissau" },
    { value: "Guyana", label: "Guyana" },
    { value: "Haiti", label: "Haiti" },
    { value: "Honduras", label: "Honduras" },
    { value: "Hungary", label: "Hungary" },
    { value: "Iceland", label: "Iceland" },
    { value: "India", label: "India" },
    { value: "Indonesia", label: "Indonesia" },
    { value: "Iran", label: "Iran" },
    { value: "Iraq", label: "Iraq" },
    { value: "Ireland {Republic}", label: "Ireland {Republic}" },
    { value: "Israel", label: "Israel" },
    { value: "Italy", label: "Italy" },
    { value: "Ivory Coast", label: "Ivory Coast" },
    { value: "Jamaica", label: "Jamaica" },
    { value: "Japan", label: "Japan" },
    { value: "Jordan", label: "Jordan" },
    { value: "Kazakhstan", label: "Kazakhstan" },
    { value: "Kenya", label: "Kenya" },
    { value: "Kiribati", label: "Kiribati" },
    { value: "Korea North", label: "Korea North" },
    { value: "Korea South", label: "Korea South" },
    { value: "Kosovo", label: "Kosovo" },
    { value: "Kuwait", label: "Kuwait" },
    { value: "Kyrgyzstan", label: "Kyrgyzstan" },
    { value: "Laos", label: "Laos" },
    { value: "Latvia", label: "Latvia" },
    { value: "Lebanon", label: "Lebanon" },
    { value: "Lesotho", label: "Lesotho" },
    { value: "Liberia", label: "Liberia" },
    { value: "Libya", label: "Libya" },
    { value: "Liechtenstein", label: "Liechtenstein" },
    { value: "Lithuania", label: "Lithuania" },
    { value: "Luxembourg", label: "Luxembourg" },
    { value: "Macedonia", label: "Macedonia" },
    { value: "Madagascar", label: "Madagascar" },
    { value: "Malawi", label: "Malawi" },
    { value: "Malaysia", label: "Malaysia" },
    { value: "Maldives", label: "Maldives" },
    { value: "Mali", label: "Mali" },
    { value: "Malta", label: "Malta" },
    { value: "Marshall Islands", label: "Marshall Islands" },
    { value: "Mauritania", label: "Mauritania" },
    { value: "Mauritius", label: "Mauritius" },
    { value: "Mexico", label: "Mexico" },
    { value: "Micronesia", label: "Micronesia" },
    { value: "Moldova", label: "Moldova" },
    { value: "Monaco", label: "Monaco" },
    { value: "Mongolia", label: "Mongolia" },
    { value: "Montenegro", label: "Montenegro" },
    { value: "Morocco", label: "Morocco" },
    { value: "Mozambique", label: "Mozambique" },
    { value: "Myanmar, {Burma}", label: "Myanmar, {Burma}" },
    { value: "Namibia", label: "Namibia" },
    { value: "Nauru", label: "Nauru" },
    { value: "Nepal", label: "Nepal" },
    { value: "Netherlands", label: "Netherlands" },
    { value: "New Zealand", label: "New Zealand" },
    { value: "Nicaragua", label: "Nicaragua" },
    { value: "Niger", label: "Niger" },
    { value: "Nigeria", label: "Nigeria" },
    { value: "Norway", label: "Norway" },
    { value: "Oman", label: "Oman" },
    { value: "Pakistan", label: "Pakistan" },
    { value: "Palau", label: "Palau" },
    { value: "Panama", label: "Panama" },
    { value: "Papua New Guinea", label: "Papua New Guinea" },
    { value: "Paraguay", label: "Paraguay" },
    { value: "Peru", label: "Peru" },
    { value: "Philippines", label: "Philippines" },
    { value: "Poland", label: "Poland" },
    { value: "Portugal", label: "Portugal" },
    { value: "Qatar", label: "Qatar" },
    { value: "Romania", label: "Romania" },
    { value: "Russian Federation", label: "Russian Federation" },
    { value: "Rwanda", label: "Rwanda" },
    { value: "St Kitts & Nevis", label: "St Kitts & Nevis" },
    { value: "St Lucia", label: "St Lucia" },
    { value: "Saint Vincent & the Grenadines", label: "Saint Vincent & the Grenadines" },
    { value: "Samoa", label: "Samoa" },
    { value: "San Marino", label: "San Marino" },
    { value: "Sao Tome & Principe", label: "Sao Tome & Principe" },
    { value: "Saudi Arabia", label: "Saudi Arabia" },
    { value: "Senegal", label: "Senegal" },
    { value: "Serbia", label: "Serbia" },
    { value: "Seychelles", label: "Seychelles" },
    { value: "Sierra Leone", label: "Sierra Leone" },
    { value: "Singapore", label: "Singapore" },
    { value: "Slovakia", label: "Slovakia" },
    { value: "Slovenia", label: "Slovenia" },
    { value: "Solomon Islands", label: "Solomon Islands" },
    { value: "Somalia", label: "Somalia" },
    { value: "South Africa", label: "South Africa" },
    { value: "South Sudan", label: "South Sudan" },
    { value: "Spain", label: "Spain" },
    { value: "Sri Lanka", label: "Sri Lanka" },
    { value: "Sudan", label: "Sudan" },
    { value: "Suriname", label: "Suriname" },
    { value: "Swaziland", label: "Swaziland" },
    { value: "Sweden", label: "Sweden" },
    { value: "Switzerland", label: "Switzerland" },
    { value: "Syria", label: "Syria" },
    { value: "Taiwan", label: "Taiwan" },
    { value: "Tajikistan", label: "Tajikistan" },
    { value: "Tanzania", label: "Tanzania" },
    { value: "Thailand", label: "Thailand" },
    { value: "Togo", label: "Togo" },
    { value: "Tonga", label: "Tonga" },
    { value: "Trinidad & Tobago", label: "Trinidad & Tobago" },
    { value: "Tunisia", label: "Tunisia" },
    { value: "Turkey", label: "Turkey" },
    { value: "Turkmenistan", label: "Turkmenistan" },
    { value: "Tuvalu", label: "Tuvalu" },
    { value: "Uganda", label: "Uganda" },
    { value: "Ukraine", label: "Ukraine" },
    { value: "United Arab Emirates", label: "United Arab Emirates" },
    { value: "United Kingdom", label: "United Kingdom" },
    { value: "United States", label: "United States" },
    { value: "Uruguay", label: "Uruguay" },
    { value: "Uzbekistan", label: "Uzbekistan" },
    { value: "Vanuatu", label: "Vanuatu" },
    { value: "Vatican City", label: "Vatican City" },
    { value: "Venezuela", label: "Venezuela" },
    { value: "Vietnam", label: "Vietnam" },
    { value: "Yemen", label: "Yemen" },
    { value: "Zambia", label: "Zambia" },
    { value: "Zimbabwe", label: "Zimbabwe" },
  ];

  export const title_data = [
    { value: "", label: "Select" },
    { value: "Mr", label: "Mr" },
    { value: "Mrs", label: "Mrs" },
    { value: "Miss", label: "Miss" },
    { value: "Dr", label: "Dr" },
    { value: "Dato", label: "Dato" },
    { value: "Dato' Seri", label: "Dato' Seri" },
    { value: "Datuk", label: "Datuk" },
    { value: "Datuk Seri", label: "Datuk Seri" },
    { value: "Datin", label: "Datin" },
    { value: "Datin Seri", label: "Datin Seri" },
    { value: "Datin Paduka", label: "Datin Paduka" },
    { value: "Tan Sri", label: "Tan Sri" },
    { value: "Tan Sri Datin Sri", label: "Tan Sri Datin Sri" },
    { value: "Tun", label: "Tun" },
    { value: "Tun Dr", label: "Tun Dr" },
    { value: "Tunku", label: "Tunku" },
    { value: "Tengku", label: "Tengku" },
    { value: "Raja", label: "Raja" },
    { value: "Encik", label: "Encik" },
    { value: "Puan", label: "Puan" },
    { value: "Cik", label: "Cik" },
    { value: "Haji", label: "Haji" },
    { value: "Hajah", label: "Hajah" },
    { value: "Syed", label: "Syed" },
    { value: "Sharifah", label: "Sharifah" },
    { value: "Professor", label: "Professor" },
    { value: "Professor Madya", label: "Professor Madya" },
    { value: "Ustaz", label: "Ustaz" },
    { value: "Ustazah", label: "Ustazah" },
    { value: "Yang Berhormat (YB)", label: "Yang Berhormat (YB)" },
    { value: "Yang Amat Berhormat (YAB)", label: "Yang Amat Berhormat (YAB)" },
    { value: "Yang Berbahagia (YBhg.)", label: "Yang Berbahagia (YBhg.)" },
  ];

  export const week_count = [
    { value: "", label: "Select" },
    { value: "Week 1", label: "Week 1" },
    { value: "Week 2", label: "Week 2" },
    { value: "Week 3", label: "Week 3" },
    { value: "Week 4", label: "Week 4" },
    { value: "Week 5", label: "Week 5" },
    { value: "Week 6", label: "Week 6" },
    { value: "Week 7", label: "Week 7" },
    { value: "Week 8", label: "Week 8" },
    { value: "Week 9", label: "Week 9" },
    { value: "Week 10", label: "Week 10" },
    { value: "Week 11", label: "Week 11" },
    { value: "Week 12", label: "Week 12" },
    { value: "Week 13", label: "Week 13" },
    { value: "Week 14", label: "Week 14" },
    { value: "Week 15", label: "Week 15" },
    { value: "Week 16", label: "Week 16" },
    { value: "Week 17", label: "Week 17" },
    { value: "Week 18", label: "Week 18" },
    { value: "Week 19", label: "Week 19" },
    { value: "Week 20", label: "Week 20" },
    { value: "Week 21", label: "Week 21" },
    { value: "Week 22", label: "Week 22" },
    { value: "Week 23", label: "Week 23" },
    { value: "Week 24", label: "Week 24" },
    { value: "Week 25", label: "Week 25" },
    { value: "Week 26", label: "Week 26" },
    { value: "Week 27", label: "Week 27" },
    { value: "Week 28", label: "Week 28" },
    { value: "Week 29", label: "Week 29" },
    { value: "Week 30", label: "Week 30" },
    { value: "Week 31", label: "Week 31" },
    { value: "Week 32", label: "Week 32" },
    { value: "Week 33", label: "Week 33" },
    { value: "Week 34", label: "Week 34" },
    { value: "Week 35", label: "Week 35" },
    { value: "Week 36", label: "Week 36" },
    { value: "Week 37", label: "Week 37" },
    { value: "Week 38", label: "Week 38" },
    { value: "Week 39", label: "Week 39" },
    { value: "Week 40", label: "Week 40" },
    { value: "Week 41", label: "Week 41" },
    { value: "Week 42", label: "Week 42" },
    { value: "Week 43", label: "Week 43" },
    { value: "Week 44", label: "Week 44" },
    { value: "Week 45", label: "Week 45" },
    { value: "Week 46", label: "Week 46" },
    { value: "Week 47", label: "Week 47" },
    { value: "Week 48", label: "Week 48" },
    { value: "Week 49", label: "Week 49" },
    { value: "Week 50", label: "Week 50" },
    { value: "Week 51", label: "Week 51" },
    { value: "Week 52", label: "Week 52" },
  ];

  export const subjects = [
    { value: "", label: "Select" },
    { value: "1", label: "Bahasa Melayu" },
    { value: "2", label: "English" },
    { value: "3", label: "Mathematics" },
    { value: "4", label: "Science" },
    { value: "5", label: "Moral Education" },
    { value: "6", label: "History" },
    { value: "7", label: "Islamic Religious Education" },
    { value: "8", label: "Tamil Religious Education" },
    { value: "9", label: "Mandarin" },
    { value: "10", label: "Geography" },
    { value: "11", label: "ICT" },
  ];